import React, { useEffect, useState } from "react";
import axios from "axios";
import { useNavigate, Link } from "react-router-dom";
import { FaArrowLeft } from "react-icons/fa";
import { API_BASE_URL } from "../config";

const getPurchaseImage = (listingId) => {
  if (!listingId) return "/images/Grass.jpg";

  if (listingId.startsWith("CLN-")) return "/images/cleaning.jpg";
  if (listingId.startsWith("POOL-")) return "/images/poolcare.jpg";

  return "/images/Grass.jpg";
};


const MyPurchases = () => {
  const navigate = useNavigate();
  const [purchases, setPurchases] = useState([]);
  const [loading, setLoading] = useState(true);
  const [handoverDelayDays, setHandoverDelayDays] = useState(7);

  const token = localStorage.getItem("token");

  useEffect(() => {
    console.log("🔑 TOKEN FOUND ON FRONTEND:", token);
    console.log("🌐 API URL:", API_BASE_URL);
    loadPurchases();
  }, []);

 const loadPurchases = async () => {
  try {
    console.log("🔥 NEW BUILD LOADED");

    const response = await fetch(`${API_BASE_URL}/api/purchases/my`, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });

    const data = await response.json();

    console.log("📦 FETCH RESPONSE:", data);

    setPurchases(data?.purchases || []);
    setHandoverDelayDays(
  data?.handoverDelayDays !== undefined
    ? Number(data.handoverDelayDays)
    : 7
);
  } catch (err) {
    console.error("❌ Error loading purchases:", err);
  } finally {
    setLoading(false);
  }
};

  // BUYER COMPLETES HANDOVER
  const buyerConfirm = async (saleId) => {
    try {
      await axios.post(
        `${API_BASE_URL}/api/handover/buyer-confirm`,
        { saleId },
        { headers: { Authorization: `Bearer ${token}` } }
      );
      alert("You have confirmed the handover.");
      loadPurchases();
    } catch (err) {
      console.error("❌ Error confirming handover:", err);
    }
  };

  const cardStyle = {
    background: "#fff",
    borderRadius: "12px",
    padding: "15px",
    border: "1px solid #ccc",
    width: "100%",
  };

 

const isDelayExpired = (sellerConfirmedAt) => {
  if (!sellerConfirmedAt) return false;

  const sellerTime = new Date(sellerConfirmedAt).getTime();

  const delayMs =
    handoverDelayDays * 24 * 60 * 60 * 1000;

  return Date.now() - sellerTime >= delayMs;
};

  const statusColor = (s) => {
    if (s === "completed") return "#2e7d32";
    if (s === "seller_done" || s === "buyer_done") return "#fb8c00";
    if (s === "handover") return "#ffb300";
    return "#0288d1"; // pending
  };

  if (loading) return <p>Loading...</p>;

  return (
    <div style={{ maxWidth: "1200px", margin: "20px auto", padding: "10px" }}>
      {/* BACK BUTTON */}
      <button
        onClick={() => navigate(-1)}
        style={{
          padding: "10px 16px",
          backgroundColor: "#2e7d32",
          color: "#fff",
          border: "none",
          borderRadius: "8px",
          cursor: "pointer",
          fontWeight: "bold",
          display: "inline-flex",
          alignItems: "center",
          gap: "8px",
          marginBottom: "20px",
        }}
      >
        <FaArrowLeft /> Back
      </button>

      <h2
        style={{
          color: "#2e7d32",
          textAlign: "center",
          marginBottom: "20px",
        }}
      >
        My Purchases
      </h2>

      {/* GRID */}
      <div
        style={{
          display: "grid",
          gridTemplateColumns: "repeat(auto-fit, minmax(300px, 1fr))",
          gap: "20px",
        }}
      >
        {purchases.length === 0 && (
          <p style={{ textAlign: "center", width: "100%", color: "#666" }}>
            No purchases found.
          </p>
        )}

        {purchases.map((p) => (
          <div key={p.saleId} style={cardStyle}>
            {/* Image */}
            <img
  src={getPurchaseImage(p.listingId)}
  alt="listing"

              style={{
                width: "100%",
                height: "180px",
                objectFit: "cover",
                borderRadius: "8px",
              }}
            />

            {/* Listing ID */}
            <p style={{ marginTop: "8px", color: "#555" }}>
              <strong>Listing:</strong> {p.listingId}
            </p>

            {/* Location */}
            <p style={{ marginTop: "4px" }}>
              <strong>Suburb:</strong> {p.suburb} {p.postcode}
            </p>

            {/* PRICE */}
            <p>
              <strong>Price:</strong> ${p.price}
            </p>

            {/* STATUS */}
            <p
              style={{
                marginTop: "10px",
                color: statusColor(p.handover_status),
                fontWeight: "bold",
              }}
            >
              Status:{" "}
              {p.handover_status === "pending" && "Handover in Progress"}
              {p.handover_status === "seller_done" && "Seller Completed"}
              {p.handover_status === "buyer_done" && "Buyer Completed"}
              {p.handover_status === "handover" && "Handover"}
              {p.handover_status === "completed" && "Completed"}
            </p>

            {/* ACTION BUTTON */}
{p.handover_status === "seller_done" && (
  <button
    onClick={() => buyerConfirm(p.saleId)}
    disabled={!isDelayExpired(p.handover_seller_at)}
    style={{
      width: "100%",
      padding: "10px",
      backgroundColor: isDelayExpired(
        p.handover_seller_at
      )
        ? "#2e7d32"
        : "#9e9e9e",
      color: "#fff",
      border: "none",
      borderRadius: "8px",
      cursor: isDelayExpired(
        p.handover_seller_at
      )
        ? "pointer"
        : "not-allowed",
      fontWeight: "bold",
      opacity: isDelayExpired(
        p.handover_seller_at
      )
        ? 1
        : 0.7,
    }}
  >
    {isDelayExpired(p.handover_seller_at)
      ? "Confirm Handover"
      : "Waiting For Clearing Period"}
  </button>
)}

            {/* HANDOVER DETAILS */}
            <Link to={`/listings-handover/${p.saleId}`}>
  <button
    style={{
      width: "100%",
      padding: "10px",
      backgroundColor: "#0288d1",
      color: "#fff",
      border: "none",
      borderRadius: "8px",
      cursor: "pointer",
      marginTop: "10px",
      fontWeight: "bold",
    }}
  >
    Handover Details
  </button>

            </Link>
          </div>
        ))}
      </div>
    </div>
  );
};

export default MyPurchases;
